module.exports = __webpack_public_path__ + "fontawesome-webfont.674f50d287a8c48dc19b.eot";


//////////////////
// WEBPACK FOOTER
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/assets/fonts/fontawesome-webfont.eot
// module id = ../../../../../src/assets/fonts/fontawesome-webfont.eot
// module chunks = styles